"use client";

import { c as _c } from "react/compiler-runtime";
import { HugeiconsIcon } from "@hugeicons/react";
import type { Route } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import UserMenu from "@/components/blocks/UserMenu";
import Logo from "@/components/brand/Logo";
import { NotificationCenter } from "@/components/notifications/notification-center";
import { isNavItemActive, NAVIGATION_ITEMS } from "@/config/navigation";
import { authClient } from "@/lib/auth-client";
export default function Header() {
  const $ = _c(34);
  const pathname = usePathname();
  const {
    data: session
  } = authClient.useSession();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== pathname || $[1] !== session?.user) {
    let t7;
    if ($[9] !== session?.user) {
      t7 = item => {
        if (item.hideOnDesktop) {
          return false;
        }
        if (!item.showInHeader) {
          return false;
        }
        if (item.protected && !session?.user) {
          return false;
        }
        return true;
      };
      $[9] = session?.user;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    const filteredNavItems = NAVIGATION_ITEMS.filter(t7);
    const isHomePage = pathname === "/";
    t5 = true;
    t6 = "z-50 border-border/70 border-none bg-background font-jakarta text-foreground/80 backdrop-blur-lg md:sticky md:top-0 dark:border-transparent";
    t3 = `fade-in mx-auto flex h-16 animate-in items-center justify-between rounded-2xl transition-all duration-700 ease-in-out md:h-17 ${isHomePage ? "w-full max-w-[100vw] px-4 md:px-6 lg:px-8 2xl:px-10" : "w-full max-w-7xl px-4 xl:px-0"}`;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Link href="/" className="flex items-center"><Logo className="text-foreground text-xl md:text-2xl" /></Link>;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t2 = "flex items-center gap-4";
    t0 = "fade-in hidden animate-in items-center gap-2 font-medium text-sm transition-all duration-300 md:flex lg:gap-4";
    let t8;
    if ($[12] !== pathname) {
      t8 = item_0 => {
        const pathString = typeof item_0.href === "string" ? item_0.href : item_0.href.pathname || "/";
        const isActive = isNavItemActive(pathname, item_0);
        return <Link key={item_0.key} href={pathString as Route} className={`flex items-center gap-2 rounded-xl border px-3.5 py-2 text-base transition-all duration-300 ${isActive ? "border-border text-foreground dark:border-transparent dark:bg-foreground/10" : "border-transparent text-foreground/60 hover:bg-foreground/5 hover:text-foreground"}`}><HugeiconsIcon icon={item_0.icon} size={22} />{item_0.label}</Link>;
      };
      $[12] = pathname;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t1 = filteredNavItems.map(t8);
    $[0] = pathname;
    $[1] = session?.user;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[14] !== t0 || $[15] !== t1) {
    t7 = <div className={t0}>{t1}</div>;
    $[14] = t0;
    $[15] = t1;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== session?.user) {
    t8 = session?.user && <NotificationCenter />;
    $[17] = session?.user;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <UserMenu />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8) {
    t10 = <div className="flex items-center gap-4">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t2 || $[24] !== t7) {
    t11 = <div className={t2}>{t7}{t10}</div>;
    $[22] = t10;
    $[23] = t2;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t3 || $[28] !== t4) {
    t12 = <nav className={t3}>{t4}{t11}</nav>;
    $[26] = t11;
    $[27] = t3;
    $[28] = t4;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t5 || $[32] !== t6) {
    t13 = <header data-app-header={t5} className={t6}>{t12}</header>;
    $[30] = t12;
    $[31] = t5;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}